import { create } from 'zustand';
import client from '@/clients/restaurant/restaurant-client';
import { storage_keys } from '@/constant/configs';
import { persist } from 'zustand/middleware';
import { UserType } from '@/lib/types/restaurant/User';
import { removeRestaurantAuthCreds } from '@/lib/utils/functions';
import { deleteFCMToken } from '@/lib/utils/fcm-cleanup';

type UserState = {
  user: UserType | null;
};

type UserActions = {
  setUser: (token: string) => Promise<boolean>;
  mutateResUser: (user: UserType) => void;
  setFetchedUser: (user: UserType) => void;
  getUpdatedUser: () => void;
  getUser: (resAuthToken?: string) => void;
  removeUser: () => Promise<void>;
  turnOffAutoRenew: () => void;
};

export const useUserStore = create<UserState & UserActions>()(
  persist(
    (set, get) => ({
      user: null,
      setUser: async (token) => {
        try {
          // Restaurant client which automatically handles auth headers
          const res = await client.get('/profile');
          if (res.status === 200) {
            const data = res.data.data as UserType;
            const userData: UserType = {
              ...data,
            };
            localStorage.setItem(
              storage_keys.restaurant_profile,
              JSON.stringify(userData)
            );

            set({ user: userData });
            return true;
          }
          return false;
        } catch (error) {
          return false;
        }
      },
      mutateResUser: (updatedUser) => {
        localStorage.setItem(
          storage_keys.restaurant_profile,
          JSON.stringify(updatedUser)
        );
        const stateUser = get().user;
        set({ user: { ...stateUser, ...updatedUser } });
      },
      // Set direct user to state, make sure data format match with profile
      setFetchedUser: (user) => {
        localStorage.setItem(
          storage_keys.restaurant_profile,
          JSON.stringify(user)
        );
        set({ user: user });
      },

      getUser: (resAuthToken?: string) => {
        if (resAuthToken) {
          const userString = localStorage.getItem(
            storage_keys.restaurant_profile
          );
          if (userString) {
            const user = JSON.parse(userString) as UserType;
            set({ user });
          } else {
            get().removeUser();
          }
        } else {
          get().removeUser();
        }
      },

      getUpdatedUser: async () => {
        const res = await client.get('/profile');
        if (res.status === 200) {
          const data = res.data.data as UserType;
          // const [language, country] = data?.locale
          //   ? data.locale.split('-')
          //   : [];
          const userData: UserType = {
            ...data,
            // locale: data.locale,
            // country,
            // language,
          };
          localStorage.setItem(
            storage_keys.restaurant_profile,
            JSON.stringify(userData)
          );
          set({ user: userData });
        }
      },

      removeUser: async () => {
        await deleteFCMToken();
        removeRestaurantAuthCreds();
        set({ user: null });
      },

      turnOffAutoRenew: () => {
        const user = get().user;
        if (!user?.related_restaurant?.active_subscription) return;

        const updatedUser = {
          ...user,
          related_restaurant: {
            ...user.related_restaurant,
            active_subscription: {
              ...user.related_restaurant.active_subscription,
              auto_renew: false,
            },
          },
        };
        set({ user: updatedUser });
      },
    }),
    {
      name: 'res_user',
    }
  )
);
